import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from '@core/local-storage.service';
import { Observable } from 'rxjs';

@Injectable()
export class DictionaryManagerService {
  private readonly localStorage = inject(LocalStorageService);

  dictionary!: Observable<string>;
  private dictionaryKey = 'dictionary';

  constructor() {
    this.dictionary = new Observable(subscriber => {
      const dictionary = this.getDictionary();
      dictionary.forEach(word => {
        subscriber.next(word);
      });
    });
  }

  addWord(word: string): void {
    const dictionary = this.getDictionary();
    dictionary.push(word);
    this.localStorage.set(this.dictionaryKey, dictionary);
  }

  private getDictionary(): string[] {
    return this.localStorage.has(this.dictionaryKey)
      ? this.localStorage.get(this.dictionaryKey)!
      : [];
  }
}
